<template>
  <div>
    <NegarBubbleIcon class="mx-auto text-blue-secondary-hover" size="100" />

    <NText variant="caption1" weight="medium" class="mt-4 text-neutral-primary">
      {{ t('symbol.bubble.description') }}
    </NText>

    <ul class="list-disc list-inside mt-2 text-neutral-secondary">
      <template v-for="(item, index) of BUBBLE_MESSAGES" :key="index">
        <li>
          <NText variant="caption1" weight="medium">{{ item }}</NText>
        </li>
      </template>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { NegarBubbleIcon } from '@negar/icons';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const BUBBLE_MESSAGES = [
  t('symbol.bubble.positiveBubbleMessage'),
  t('symbol.bubble.negativeBubbleMessage'),
];
</script>
